type LinkRequestState = 'ACCEPTED' | 'REJECTED' | 'CANCELLED';

export class LinkRequestMustBePendingError extends Error {
    constructor(
        public readonly currentState: LinkRequestState,
        message: string,
    ) {
        super(message);
    }
}
